import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';


type DataPoint = {
    x: string; // Version
    y: number[]; // Sentiment counts [positive, negative, neutral]
};

type ReviewVolumeProps = {
    data: DataPoint[];
    annotations?: XAxisAnnotations[];
};


function ReviewsByVersion({ data, annotations }: ReviewVolumeProps) {
    const options: ApexOptions = {
        chart: {
            type: "line",
            zoom: { enabled: false },
            toolbar: { show: false },
            animations: { enabled: false }
        },
        colors: ["#008FFB"],
        annotations: { xaxis: annotations ?? [] },
        xaxis: {
            categories: data.map(({ x }) => x),
            axisBorder: { show: false }, // Remove axis border
            axisTicks: { show: false }
        },
        yaxis: {
            min: 0,
            axisBorder: { show: false }, // Remove axis border
            axisTicks: { show: false }
        },
        stroke: { curve: 'straight', width: 3 },
        dataLabels: {
            enabled: true
        },
        tooltip: {
            y: { formatter: (value) => `${value} reviews` },
        },
        grid: {
            borderColor: "#E5E7EB",
            strokeDashArray: 3
        },
    };

    const series = [
        {
            name: "Reviews",
            data: data.map(({ y }) => y),
        },
    ];

    return <ReactApexChart
        options={options}
        series={series}
        type="line"
        height={200}
        width="95%"
    />;

}

export default ReviewsByVersion;